'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _partial2 = require('lodash/partial');

var _partial3 = _interopRequireDefault(_partial2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getStateProps = getStateProps;
exports.preventDefault = preventDefault;
exports.getSubmitHandler = getSubmitHandler;

var _reactRedux = require('react-redux');

var _capeRedux = require('cape-redux');

var _reduxField = require('redux-field');

var _utils = require('./utils');

var _FieldGroupEl = require('./FieldGroupEl');

var _FieldGroupEl2 = _interopRequireDefault(_FieldGroupEl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStateProps(state, props) {
  var fieldState = (0, _reduxField.getState)(state, props);
  return {
    id: (0, _utils.getFieldId)(props),
    isSaving: props.isActive && fieldState.isSaving,
    status: fieldState.status,
    value: fieldState.value
  };
}
var getActions = (0, _capeRedux.mapDispatchToProps)(function (_ref) {
  var prefix = _ref.prefix;
  return {
    onSubmit: (0, _partial3.default)(_reduxField.onSubmit, prefix)
  };
});
function preventDefault(event) {
  if (event && event.preventDefault) event.preventDefault();
}
// Only create a submit handler when the form is active.
function getSubmitHandler(stateProps, dispatchProps, ownProps) {
  if (!ownProps.isActive) return undefined;
  // This would be the place to add an additional onSubmit handler.
  // Propbably want to use middleware to listen to this action instead?
  return (0, _flow3.default)(preventDefault, (0, _partial3.default)(dispatchProps.onSubmit, stateProps.value));
}
function mergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, {
    onSubmit: getSubmitHandler(stateProps, dispatchProps, ownProps)
  });
}
exports.default = (0, _reactRedux.connect)(getStateProps, getActions, mergeProps)(_FieldGroupEl2.default);


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/Editable/FieldGroup.js
// module id = 675
// module chunks = 0